/* ============================================================
   gatsby-enhancements.js

   Small progressive enhancements that need markup the section
   files own. Each one is written so it becomes a NO-OP once the
   real markup ships, so nothing double-applies after a push.
   ============================================================ */
(function () {
  'use strict';

  /* Spirits page: make the flagship bottle click through to the PDP.
     sections/gatsby-spirits.liquid now does this in Liquid, but that file
     is too large to write through the theme files API, so until it is
     pushed with the CLI this shim supplies the same link at runtime.
     Guard: if the image is already inside an anchor, do nothing. */
  function linkFlagshipBottle() {
    var visual = document.querySelector('.ghp-flagship__visual');
    if (!visual) return;

    var img = visual.querySelector('img');
    if (!img || img.closest('a')) return;

    var cta = document.querySelector('.ghp-flagship__actions a[href]');
    if (!cta) return;

    var name = document.querySelector('.ghp-flagship__name');
    var link = document.createElement('a');
    link.className = 'ghp-flagship__visual-link';
    link.href = cta.getAttribute('href');
    link.setAttribute(
      'aria-label',
      'View ' + ((name && name.textContent.trim()) || 'product') + ' details'
    );

    img.parentNode.insertBefore(link, img);
    link.appendChild(img);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', linkFlagshipBottle);
  } else {
    linkFlagshipBottle();
  }
})();
